var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"empty-image",attrs:{"src":_vm.emptyImage}}),_c('h6',{staticClass:"text-center"},[_vm._v("\n        "+_vm._s(_vm.caption)+"\n    ")]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }